export const HOME = { emergentLink: "home-emergent-link" };

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submitBtn: "auth-submit-btn",
  toggleModeBtn: "auth-toggle-mode-btn",
  googleBtn: "auth-google-btn",
  logoutBtn: "auth-logout-btn",
};

export const NAV = {
  sidebar: "app-sidebar",
  dashboard: "nav-dashboard",
  properties: "nav-properties",
  rooms: "nav-rooms",
  reservations: "nav-reservations",
  timeline: "nav-timeline",
  rates: "nav-rates",
  guests: "nav-guests",
  invoices: "nav-invoices",
  housekeeping: "nav-housekeeping",
  channels: "nav-channels",
  staff: "nav-staff",
  reports: "nav-reports",
  settings: "nav-settings",
  propertySwitcher: "property-switcher",
};

export const RES = {
  newBtn: "reservation-new-btn",
  submitBtn: "reservation-submit-btn",
  checkinBtn: "reservation-checkin-btn",
  checkoutBtn: "reservation-checkout-btn",
  cancelBtn: "reservation-cancel-btn",
  guestSelect: "reservation-guest-select",
  roomSelect: "reservation-room-select",
  checkInDate: "reservation-checkin-date",
  checkOutDate: "reservation-checkout-date",
};

export const ROOM = {
  newBtn: "room-new-btn",
  submitBtn: "room-submit-btn",
};

export const GUEST = {
  newBtn: "guest-new-btn",
  submitBtn: "guest-submit-btn",
};

export const HK = {
  newBtn: "hk-new-btn",
  markInProgress: "hk-in-progress",
  markDone: "hk-done",
};

export const INV = {
  generateBtn: "invoice-generate-btn",
  markPaidBtn: "invoice-mark-paid-btn",
};

export const SETTINGS = {
  saveBtn: "settings-save-btn",
};
